import React from 'react';

const AudioPreview = ({ uri }) => {
  return <audio style={{ width: '100%' }} controls loop className="audio-preview" src={uri} />;
};

export default AudioPreview;
